"use client";

import { c as _c } from "react/compiler-runtime";
import SubmissionCarouselSection from "./SubmissionCarouselSection";
import { NowMintingSection } from "./now-minting";
import { NextMintLeadingSection } from "./next-mint-leading";
import { BoostedSection } from "./boosted";
import { ExploreWavesSection } from "./explore-waves";
import { HeroHeader } from "./hero";
export default function HomePageContent() {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HeroHeader />;
    t1 = <NowMintingSection />;
    t2 = <SubmissionCarouselSection />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-overflow-x-hidden tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-900">{t0}{t1}{t2}<div className="tw-mt-10 tw-border tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-10 md:tw-mt-16 md:tw-pt-16"><NextMintLeadingSection /><BoostedSection /><ExploreWavesSection /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}